








import Vue, { PropOptions } from 'vue';
import { BillingAccount } from '~/services/BillingService';
import PlanSelect from '../components/PlanSelect.vue';
import CourseraBillingPlan from '../components/CourseraBillingPlan.vue';
import { SelectOption } from '../types';

export default Vue.extend({
    name: 'Subscriptions',
    components: {
        PlanSelect,
        CourseraBillingPlan,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
    },
    data() {
        return {
            selectedPlan: null as SelectOption | null,
        };
    },
    computed: {
        plan(): string | null {
            return !!this.selectedPlan ? this.selectedPlan.value : null;
        },
    },
});
